// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== GRID LAYOUT ==================== */

/* Main Grid Layout Container */
.mm-grid-layout {
  width: 100%;
  height: 100%;
  position: relative;
}

/* Grid Container - Responsive */
.mm-grid-container {
  display: grid;
  gap: clamp(0.5rem, 1vw, 1rem);
  width: 100%;
  height: auto;
  padding: clamp(0.5rem, 1vw, 1rem);
  box-sizing: border-box;
}

/* Grid Item */
.mm-grid-item {
  position: relative;
  width: 100%;
  aspect-ratio: 1 / 1;
  overflow: hidden;
  border-radius: clamp(0.5rem, 1vw, 1rem);
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  background: rgba(0, 0, 0, 0.05);
}

.mm-grid-item:hover {
  transform: scale(1.03);
  box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.15);
}

/* Grid Media */
.mm-grid-media {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

/* ==================== SINGLE MEDIA ==================== */

.mm-single-media-container {
  width: 100%;
  height: 100%;
  min-height: 20rem;
  max-height: 40rem;
}

.mm-single-media-wrapper {
  width: 100%;
  height: 100%;
  border-radius: clamp(0.5rem, 1vw, 1.25rem);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.mm-single-media-wrapper:hover {
  transform: scale(1.01);
}

.mm-single-media-wrapper img,
.mm-single-media-wrapper video {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* ==================== MODAL ==================== */

.mm-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
  padding: clamp(1rem, 2vw, 2rem);
  box-sizing: border-box;
  overflow-y: auto;
}

.mm-modal-container {
  position: relative;
  width: 100%;
  max-width: 90rem;
  background: rgba(36,36,45,0.2);
  border-radius: clamp(0.75rem, 1.5vw, 1.5rem);
  overflow: hidden;
  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5);
}

.mm-modal-close {
  position: absolute;
  top: clamp(0.5rem, 1vw, 1rem);
  right: clamp(0.5rem, 1vw, 1rem);
  width: clamp(2rem, 3vw, 2.5rem);
  height: clamp(2rem, 3vw, 2.5rem);
  border: none;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  font-size: clamp(1rem, 2vw, 1.5rem);
  border-radius: 50%;
  cursor: pointer;
  z-index: 10001;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.3s ease, transform 0.2s ease;
}

.mm-modal-close:hover {
  background: rgba(0, 0, 0, 0.8);
  transform: scale(1.1);
}

.mm-modal-content {
  display: grid;
  grid-template-columns: 1fr;
  gap: 0;
}

/* Modal Media Section */
.mm-modal-media-section {
  width: 100%;
  max-height: 50vh;
  background: black;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.mm-modal-media {
  width: 100%;
  height: 100%;
  max-height: 50vh;
  object-fit: contain;
}

/* Modal Details Section */
.mm-modal-details-section {
  padding: clamp(1rem, 2vw, 2rem);
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 1.5vw, 1.5rem);
  max-height: 50vh;
  overflow-y: auto;
}

/* User Info */
.mm-modal-user-info {
  display: flex;
  align-items: center;
  gap: clamp(0.5rem, 1vw, 1rem);
  padding-bottom: clamp(0.5rem, 1vw, 1rem);
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}

.mm-modal-user-avatar {
  width: clamp(2.5rem, 4vw, 3rem);
  height: clamp(2.5rem, 4vw, 3rem);
  border-radius: 50%;
  object-fit: cover;
}

.mm-modal-user-details {
  flex: 1 1;
}

.mm-modal-username {
  margin: 0;
  font-size: clamp(0.875rem, 1.5vw, 1.125rem);
  font-weight: bold;
  color: #1a1a1a;
}

.mm-modal-location {
  margin: 0;
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  color: #666;
}

/* Description */
.mm-modal-description {
  margin: 0;
  font-size: clamp(0.875rem, 1.3vw, 1rem);
  line-height: 1.6;
  color: #333;
}

/* Stats */
.mm-modal-stats {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));
  gap: clamp(0.5rem, 1vw, 1rem);
  padding: clamp(0.75rem, 1.5vw, 1rem);
  background: rgba(0, 0, 0, 0.03);
  border-radius: clamp(0.5rem, 1vw, 0.75rem);
  display: "flex";
  flex-direction: row;
}

.mm-modal-stats-left {
  width: "80%";
  height: "100%";
  display: "flex";
  flex-direction: "row";
  justify-items: flex-start;
  background: "red";
}

.mm-modal-stats-right {
  width: "20%";
  height: "100%";
  display: "flex";
  flex-direction: "row";
  justify-items: flex-end;
  margin-right: 20px;
}

.mm-modal-stat-item {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.25rem;
}

.mm-modal-stat-icon {
  font-size: clamp(1.25rem, 2vw, 1.5rem);
  color: "white";
  font-size: 15px;
  font-weight: bold;
}

.mm-modal-stat-value {
  font-size: clamp(0.875rem, 1.3vw, 1rem);
  color: white;
  font-size: 15px;
  font-weight: bold;
}

/* Comments Section */
.mm-modal-comments-section {
  display: flex;
  flex-direction: column;
  gap: clamp(0.75rem, 1.5vw, 1rem);
}

.mm-modal-comments-title {
  margin: 0;
  font-size: clamp(1rem, 1.5vw, 1.125rem);
  font-weight: bold;
  color: white;
}

.mm-modal-comments-list {
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 1vw, 0.75rem);
  max-height: 15rem;
  overflow-y: auto;
  padding: clamp(0.5rem, 1vw, 0.75rem);
  background: rgba(0, 0, 0, 0.02);
  border-radius: clamp(0.5rem, 1vw, 0.75rem);
  height: 140px;
}

.mm-modal-comment {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  padding-bottom: clamp(0.5rem, 1vw, 0.75rem);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.mm-modal-comment:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.mm-modal-comment-user {
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  font-weight: bold;
  color: #1a1a1a;
}

.mm-modal-comment-text {
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  color: #333;
  line-height: 1.5;
}

.mm-modal-comment-time {
  font-size: clamp(0.625rem, 1vw, 0.75rem);
  color: #999;
}

.mm-modal-no-comments {
  text-align: center;
  color: #999;
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  padding: clamp(1rem, 2vw, 1.5rem);
}

/* Add Comment */
.mm-modal-add-comment {
  display: flex;
  gap: clamp(0.5rem, 1vw, 0.75rem);
}

.mm-modal-comment-input {
  flex: 1 1;
  padding: clamp(0.5rem, 1vw, 0.75rem);
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: clamp(0.5rem, 1vw, 0.75rem);
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  outline: none;
  transition: border-color 0.3s ease;
  background: rgba(36,36,45,0.2);
  color: white;
}

.mm-modal-comment-input:focus {
  border-color: #007bff;
}

.mm-modal-comment-button {
  padding: clamp(0.5rem, 1vw, 0.75rem) clamp(1rem, 2vw, 1.5rem);
  background: #007bff;
  color: white;
  border: none;
  border-radius: clamp(0.5rem, 1vw, 0.75rem);
  font-size: clamp(0.75rem, 1.2vw, 0.875rem);
  font-weight: bold;
  cursor: pointer;
  transition: background 0.3s ease, transform 0.2s ease;
}

.mm-modal-comment-button:hover {
  background: #0056b3;
  transform: translateY(-0.125rem);
}

/* Audio Container */
.mm-audio-container {
  display: flex;
  flex-direction: column;
  gap: clamp(0.5rem, 1vw, 0.75rem);
  padding: clamp(0.75rem, 1.5vw, 1rem);
  background: rgba(0, 0, 0, 0.05);
  border-radius: clamp(0.5rem, 1vw, 0.75rem);
}

.mm-audio-container audio {
  width: 100%;
}

/* ==================== RESPONSIVE BREAKPOINTS ==================== */

/* Tablet and larger */
@media (min-width: 48rem) {
  .mm-modal-content {
    grid-template-columns: 1.5fr 1fr;
  }

  .mm-modal-media-section {
    max-height: 80vh;
  }

  .mm-modal-media {
    max-height: 80vh;
  }

  .mm-modal-details-section {
    max-height: 80vh;
  }
}

/* Mobile optimization */
@media (max-width: 47.9375rem) {
  .mm-grid-container {
    grid-template-columns: repeat(2, 1fr) !important;
  }

  .mm-modal-overlay {
    padding: 0;
  }

  .mm-modal-container {
    border-radius: 0;
    height: 100%;
  }

  .mm-modal-content {
    height: 100%;
  }

  .mm-modal-details-section {
    max-height: none;
  }
}


/* ============================================ */
/*  LOGO + QUALITY STARS ROW                    */
/* ============================================ */
.mm-logo-quality-row {
  display: flex;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 10px 0;
  margin-bottom: 8px;
}

.mm-logo-wrap {
  flex-shrink: 0;
}

.mm-modal-logo {
  height: 40px;
  width: 40px;
  object-fit: contain;
  border-radius: 8px;
}

.mm-quality-stars {
  display: flex;
  align-items: center;
  gap: 2px;
}

.mm-quality-label {
  margin-left: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #FFD700;
  letter-spacing: 0.04em;
}

/* ============================================ */
/*  ABOUT SECTION                               */
/* ============================================ */
.mm-about-section {
  width: 100%;
  padding: 12px 14px;
  border-radius: 10px;
  margin-bottom: 12px;
  margin-top: -20px;
}

.mm-about-row {
  display: flex;
  gap: 8px;
  padding: 4px 0;
  font-size: 13px;
}

.mm-about-label {
  color: rgba(255, 255, 255, 0.5);
  flex-shrink: 0;
  min-width: 90px;
}

.mm-about-value {
  color: rgba(255, 255, 255, 0.9);
}

/* ============================================ */
/*  METADATA INPUTS (highlighted)               */
/* ============================================ */
.mm-metadata-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 0;
  margin-top: 6px;
}

.mm-metadata-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  min-width: 110px;
}

.mm-metadata-select {
  flex: 1 1;
  height: 32px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid rgba(168, 139, 250, 0.2);
  background: rgba(36, 36, 45, 0.5);
  color: white;
  font-size: 12px;
  cursor: pointer;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

/* Highlighted state — draws the eye to these two fields */
.mm-metadata-select--highlight {
  border-color: rgba(255, 193, 7, 0.4);
  background: rgba(255, 193, 7, 0.08);
  color: #ffc107;
  font-weight: 600;
}

.mm-metadata-select--highlight:hover,
.mm-metadata-select--highlight:focus {
  border-color: rgba(255, 193, 7, 0.7);
  box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.15);
  outline: none;
}

.mm-metadata-select--highlight option {
  background: #1a1a22;
  color: white;
  font-weight: 400;
}

/* ============================================ */
/*  DOUBLE-CLICK LIKE HINT                      */
/* ============================================ */
.mm-double-click-hint {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.4);
  text-align: center;
  margin-top: 8px;
  letter-spacing: 0.03em;
}

/* ============================================ */
/*  ACTION BUTTONS (Share / Suggest)            */
/* ============================================ */
.mm-action-btn-wrapper {
  position: relative;
}

.mm-action-btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px;
  border-radius: 8px;
  border: 1px solid gray;
  background: rgba(36,36,45,0.2);
  color: white;
  cursor: pointer;
  font-size: 13px;
  transition: background 0.18s ease, border-color 0.18s ease;
}

/* ============================================ */
/*  SHARE DROPDOWN                              */
/* ============================================ */
.mm-share-dropdown {
  position: absolute;
  bottom: 100%;
  left: 0;
  margin-bottom: 8px;
  background: rgba(20, 20, 28, 0.98);
  border: 1px solid rgba(168, 139, 250, 0.25);
  border-radius: 12px;
  padding: 6px;
  min-width: 180px;
  z-index: 100;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.mm-share-option {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 14px;
  border: none;
  background: transparent;
  color: white;
  cursor: pointer;
  border-radius: 8px;
  font-size: 13px;
  text-align: left;
  transition: background 0.15s ease;
}

.mm-share-option:hover {
  background: rgba(168, 139, 250, 0.15);
}

.mm-share-icon {
  width: 24px;
  height: 24px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  flex-shrink: 0;
}

.mm-share-icon--facebook { background: #1877F2; color: white; }
.mm-share-icon--instagram { background: #E1306C; }
.mm-share-icon--snapchat { background: #FFFC00; }
.mm-share-icon--tiktok { background: #000; color: white; border: 1px solid #25F4EE; }

/* ============================================ */
/*  SUGGEST MODAL                               */
/* ============================================ */
.mm-suggest-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.7);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 200;
}

.mm-suggest-modal {
  background: rgba(20, 20, 28, 0.98);
  border: 1px solid darkslategray;
  border-radius: 16px;
  padding: 28px 32px;
  width: 90%;
  max-width: 420px;
  position: relative;
}

.mm-suggest-close {
  position: absolute;
  top: 12px;
  right: 16px;
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.6);
  font-size: 18px;
  cursor: pointer;
}

.mm-suggest-close:hover { color: white; }

.mm-suggest-title {
  font-size: 18px;
  font-weight: 700;
  color: white;
  margin: 0 0 8px 0;
}

.mm-suggest-help {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.5);
  line-height: 1.5;
  margin: 0 0 20px 0;
}

.mm-suggest-input-row {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-bottom: 24px;
}

.mm-suggest-label {
  font-size: 12px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.7);
  letter-spacing: 0.04em;
}

.mm-suggest-input {
  height: 42px;
  padding: 0 14px;
  border-radius: 10px;
  border: 1px solid rgba(168, 139, 250, 0.25);
  background: rgba(36, 36, 45, 0.6);
  color: white;
  font-size: 14px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.mm-suggest-input:focus {
  border-color: rgba(168, 139, 250, 0.6);
  box-shadow: 0 0 0 3px rgba(168, 139, 250, 0.12);
}

.mm-suggest-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.mm-suggest-actions {
  display: flex;
  gap: 12px;
  justify-content: flex-end;
}

.mm-suggest-cancel {
  padding: 10px 18px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  background: transparent;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  font-size: 13px;
  transition: background 0.15s ease;
}

.mm-suggest-cancel:hover {
  background: rgba(255, 255, 255, 0.06);
}

.mm-suggest-submit {
  padding: 10px 22px;
  border-radius: 10px;
  border: none;
  background: linear-gradient(135deg, #7c3aed, #4c1d95);
  color: white;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  transition: opacity 0.15s ease, transform 0.15s ease;
}

.mm-suggest-submit:hover { transform: translateY(-1px); }
.mm-suggest-submit:disabled {
  opacity: 0.4;
  cursor: not-allowed;
  transform: none;
}

/* ============================================ */
/*  TOAST NOTIFICATION                          */
/* ============================================ */
.mm-toast {
  position: fixed;
  bottom: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(20, 20, 28, 0.98);
  border: 1px solid rgba(168, 139, 250, 0.3);
  border-radius: 12px;
  padding: 14px 24px;
  color: white;
  font-size: 13px;
  z-index: 300;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);
  animation: mmToastIn 0.3s ease;
}

@keyframes mmToastIn {
  from { opacity: 0; transform: translate(-50%, 20px); }
  to   { opacity: 1; transform: translate(-50%, 0); }
}

/* ============================================ */
/*  METADATA HIGHLIGHT (from previous update)   */
/* ============================================ */
.mm-metadata-highlight {
  background: rgba(255, 193, 7, 0.1);
  color: #ffc107;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  border: 1px solid rgba(255, 193, 7, 0.25);
}

.mm-metadata-value {
  font-size: 13px;
  margin: 0;
}

/* ============================================ */
/*  COMMENT THREAD + REPLY BUTTON               */
/* ============================================ */
.mm-comment-thread {
  margin-bottom: 12px;
}

.mm-modal-comment {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 8px 12px;
  border-radius: 10px;
  background: rgba(36, 36, 45, 0.3);
  border: 1px solid rgba(168, 139, 250, 0.1);
}

.mm-comment-body {
  flex: 1 1;
  min-width: 0;
  font-size: 13px;
  line-height: 1.5;
}

/* Reply button */
.mm-reply-btn {
  flex-shrink: 0;
  padding: 4px 12px;
  border-radius: 6px;
  border: 1px solid darkslategray;
  background: transparent;
  color: gray;
  font-size: 11px;
  font-weight: 600;
  cursor: pointer;
  letter-spacing: 0.03em;
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

/* .mm-reply-btn:hover {
  background: rgba(168, 139, 250, 0.12);
  border-color: rgba(168, 139, 250, 0.5);
  color: #a78bfa;
}

.mm-reply-btn--active {
  background: rgba(255, 99, 99, 0.12);
  border-color: rgba(255, 99, 99, 0.4);
  color: #ff6363;
} */

/* ============================================ */
/*  INLINE REPLY INPUT                          */
/* ============================================ */
.mm-reply-input-row {
  margin-top: 8px;
  margin-left: 24px;
  padding: 10px 14px;
  border-radius: 10px;
  background: rgba(36,36,45,0.2);
  border: 1px solid darkslategray;
}

.mm-reply-mention {
  display: block;
  font-size: 11px;
  color: rgba(168, 139, 250, 0.7);
  margin-bottom: 6px;
  font-style: italic;
}

.mm-reply-input-controls {
  display: flex;
  gap: 8px;
}

.mm-reply-input {
  flex: 1 1;
  height: 34px;
  padding: 0 12px;
  border-radius: 8px;
  border: 1px solid rgba(168, 139, 250, 0.2);
  background: rgba(36, 36, 45, 0.6);
  color: white;
  font-size: 12px;
  outline: none;
  transition: border-color 0.18s ease;
}

.mm-reply-input:focus {
  border-color: rgba(168, 139, 250, 0.5);
}

.mm-reply-input::placeholder {
  color: rgba(255, 255, 255, 0.3);
}

.mm-reply-submit-btn {
  flex-shrink: 0;
  padding: 0 16px;
  height: 34px;
  border-radius: 8px;
  border: none;
  background: rgba(36,36,45,0.2);
  color: white;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s ease, transform 0.15s ease;
  border: "1px solid darkslategray";
}

.mm-reply-submit-btn:hover { transform: translateY(-1px); }
.mm-reply-submit-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
  transform: none;
}

/* ============================================ */
/*  NESTED REPLIES                              */
/* ============================================ */
.mm-replies-container {
  margin-top: 8px;
  margin-left: 24px;
  padding-left: 14px;
  border-left: 2px solid rgba(168, 139, 250, 0.2);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.mm-reply-item {
  display: flex;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background: rgba(36, 36, 45, 0.2);
}

/* Small avatar with first letter of the replier's userId */
.mm-reply-avatar {
  flex-shrink: 0;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: linear-gradient(135deg, #7c3aed, #4c1d95);
  display: flex;
  align-items: center;
  justify-content: center;
}

.mm-reply-avatar-text {
  font-size: 12px;
  font-weight: 700;
  color: white;
  text-transform: uppercase;
}

.mm-reply-content {
  flex: 1 1;
  min-width: 0;
}

.mm-reply-header {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
  margin-bottom: 2px;
}

.mm-reply-user {
  font-size: 12px;
  color: #a78bfa;
}

/* "→ @username" shown when the reply is addressed to someone
   other than the parent comment's author */
.mm-reply-mention-inline {
  font-size: 11px;
  color: rgba(168, 139, 250, 0.6);
  font-style: italic;
}

.mm-reply-time {
  font-size: 10px;
  color: rgba(255, 255, 255, 0.3);
  margin-left: auto;
}

.mm-reply-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.85);
  line-height: 1.4;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/Grid/gridMode.css"],"names":[],"mappings":"AAAA,0DAA0D;;AAE1D,+BAA+B;AAC/B;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA,gCAAgC;AAChC;EACE,aAAa;EACb,6BAA6B;EAC7B,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,sBAAsB;AACxB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,gBAAgB;EAChB,uCAAuC;EACvC,eAAe;EACf,qDAAqD;EACrD,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;EACtB,6CAA6C;AAC/C;;AAEA,eAAe;AACf;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA,2DAA2D;;AAE3D;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,gBAAgB;EAChB,eAAe;EACf,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,oDAAoD;;AAEpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,+BAA+B;EAC/B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,4CAA4C;EAC5C,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,+BAA+B;EAC/B,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,mCAAmC;EACnC,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,0BAA0B;EAC1B,MAAM;AACR;;AAEA,wBAAwB;AACxB;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,mBAAmB;EACnB,6BAA6B;EAC7B,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,SAAS;EACT,2CAA2C;EAC3C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,0CAA0C;EAC1C,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,SAAS;EACT,uCAAuC;EACvC,gBAAgB;EAChB,WAAW;AACb;;AAEA,UAAU;AACV;EACE,aAAa;EACb,0DAA0D;EAC1D,6BAA6B;EAC7B,oCAAoC;EACpC,+BAA+B;EAC/B,0CAA0C;EAC1C,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,sCAAsC;EACtC,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,uCAAuC;EAEvC,YAAY;EACZ,eAAe;EACf,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,uCAAuC;EACvC,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,iBAAiB;EACjB,gBAAgB;EAChB,oCAAoC;EACpC,+BAA+B;EAC/B,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,2CAA2C;EAC3C,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,0CAA0C;EAC1C,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,0CAA0C;EAC1C,iCAAiC;AACnC;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,SAAO;EACP,oCAAoC;EACpC,oCAAoC;EACpC,0CAA0C;EAC1C,0CAA0C;EAC1C,aAAa;EACb,kCAAkC;EAClC,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,6DAA6D;EAC7D,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,0CAA0C;EAC1C,0CAA0C;EAC1C,iBAAiB;EACjB,eAAe;EACf,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,sBAAsB;EACtB,gCAAgC;EAChC,oCAAoC;EACpC,+BAA+B;EAC/B,0CAA0C;AAC5C;;AAEA;EACE,WAAW;AACb;;AAEA,qEAAqE;;AAErE,sBAAsB;AACtB;EACE;IACE,gCAAgC;EAClC;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,gDAAgD;EAClD;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,gBAAgB;EAClB;AACF;;;AAGA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,+BAA+B;AACjC;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wDAAwD;AAC1D;;AAEA,0DAA0D;AAC1D;EACE,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,oCAAoC;EACpC,6CAA6C;EAC7C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,eAAe;EACf,0DAA0D;AAC5D;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,kBAAkB;EAClB,kCAAkC;EAClC,2CAA2C;EAC3C,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B,mBAAmB,EAAE,YAAY,EAAE;AAC9D,4BAA4B,mBAAmB,EAAE;AACjD,2BAA2B,mBAAmB,EAAE;AAChD,yBAAyB,gBAAgB,EAAE,YAAY,EAAE,yBAAyB,EAAE;;AAEpF,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,+BAA+B;EAC/B,eAAe;EACf,eAAe;AACjB;;AAEA,0BAA0B,YAAY,EAAE;;AAExC;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,+BAA+B;EAC/B,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,2CAA2C;EAC3C,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,0DAA0D;AAC5D;;AAEA;EACE,sCAAsC;EACtC,+CAA+C;AACjD;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,uBAAuB;EACvB,+BAA+B;EAC/B,eAAe;EACf,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,oDAAoD;AACtD;;AAEA,2BAA2B,2BAA2B,EAAE;AACxD;EACE,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,eAAe;EACf,YAAY;EACZ,SAAS;EACT,2BAA2B;EAC3B,kCAAkC;EAClC,0CAA0C;EAC1C,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,OAAO,UAAU,EAAE,gCAAgC,EAAE;EACrD,OAAO,UAAU,EAAE,6BAA6B,EAAE;AACpD;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,iCAAiC;EACjC,0CAA0C;AAC5C;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,+BAA+B;EAC/B,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,4EAA4E;AAC9E;;AAEA;;;;;;;;;;GAUG;;AAEH,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,0CAA0C;EAC1C,iCAAiC;EACjC,YAAY;EACZ,eAAe;EACf,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,8BAA8B;EAC9B,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oDAAoD;EACpD,iCAAiC;AACnC;;AAEA,6BAA6B,2BAA2B,EAAE;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA,iDAAiD;AACjD,iDAAiD;AACjD,iDAAiD;AACjD;EACE,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,+CAA+C;EAC/C,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,iCAAiC;AACnC;;AAEA,2DAA2D;AAC3D;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,qDAAqD;EACrD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;2CAC2C;AAC3C;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gCAAgC;EAChC,gBAAgB;AAClB","sourcesContent":["/* ==================== GRID LAYOUT ==================== */\n\n/* Main Grid Layout Container */\n.mm-grid-layout {\n  width: 100%;\n  height: 100%;\n  position: relative;\n}\n\n/* Grid Container - Responsive */\n.mm-grid-container {\n  display: grid;\n  gap: clamp(0.5rem, 1vw, 1rem);\n  width: 100%;\n  height: auto;\n  padding: clamp(0.5rem, 1vw, 1rem);\n  box-sizing: border-box;\n}\n\n/* Grid Item */\n.mm-grid-item {\n  position: relative;\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  overflow: hidden;\n  border-radius: clamp(0.5rem, 1vw, 1rem);\n  cursor: pointer;\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  background: rgba(0, 0, 0, 0.05);\n}\n\n.mm-grid-item:hover {\n  transform: scale(1.03);\n  box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.15);\n}\n\n/* Grid Media */\n.mm-grid-media {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n/* ==================== SINGLE MEDIA ==================== */\n\n.mm-single-media-container {\n  width: 100%;\n  height: 100%;\n  min-height: 20rem;\n  max-height: 40rem;\n}\n\n.mm-single-media-wrapper {\n  width: 100%;\n  height: 100%;\n  border-radius: clamp(0.5rem, 1vw, 1.25rem);\n  overflow: hidden;\n  cursor: pointer;\n  transition: transform 0.3s ease;\n}\n\n.mm-single-media-wrapper:hover {\n  transform: scale(1.01);\n}\n\n.mm-single-media-wrapper img,\n.mm-single-media-wrapper video {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* ==================== MODAL ==================== */\n\n.mm-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.9);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 10000;\n  padding: clamp(1rem, 2vw, 2rem);\n  box-sizing: border-box;\n  overflow-y: auto;\n}\n\n.mm-modal-container {\n  position: relative;\n  width: 100%;\n  max-width: 90rem;\n  background: rgba(36,36,45,0.2);\n  border-radius: clamp(0.75rem, 1.5vw, 1.5rem);\n  overflow: hidden;\n  box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.5);\n}\n\n.mm-modal-close {\n  position: absolute;\n  top: clamp(0.5rem, 1vw, 1rem);\n  right: clamp(0.5rem, 1vw, 1rem);\n  width: clamp(2rem, 3vw, 2.5rem);\n  height: clamp(2rem, 3vw, 2.5rem);\n  border: none;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  font-size: clamp(1rem, 2vw, 1.5rem);\n  border-radius: 50%;\n  cursor: pointer;\n  z-index: 10001;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n.mm-modal-close:hover {\n  background: rgba(0, 0, 0, 0.8);\n  transform: scale(1.1);\n}\n\n.mm-modal-content {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: 0;\n}\n\n/* Modal Media Section */\n.mm-modal-media-section {\n  width: 100%;\n  max-height: 50vh;\n  background: black;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.mm-modal-media {\n  width: 100%;\n  height: 100%;\n  max-height: 50vh;\n  object-fit: contain;\n}\n\n/* Modal Details Section */\n.mm-modal-details-section {\n  padding: clamp(1rem, 2vw, 2rem);\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.75rem, 1.5vw, 1.5rem);\n  max-height: 50vh;\n  overflow-y: auto;\n}\n\n/* User Info */\n.mm-modal-user-info {\n  display: flex;\n  align-items: center;\n  gap: clamp(0.5rem, 1vw, 1rem);\n  padding-bottom: clamp(0.5rem, 1vw, 1rem);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\n}\n\n.mm-modal-user-avatar {\n  width: clamp(2.5rem, 4vw, 3rem);\n  height: clamp(2.5rem, 4vw, 3rem);\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.mm-modal-user-details {\n  flex: 1;\n}\n\n.mm-modal-username {\n  margin: 0;\n  font-size: clamp(0.875rem, 1.5vw, 1.125rem);\n  font-weight: bold;\n  color: #1a1a1a;\n}\n\n.mm-modal-location {\n  margin: 0;\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  color: #666;\n}\n\n/* Description */\n.mm-modal-description {\n  margin: 0;\n  font-size: clamp(0.875rem, 1.3vw, 1rem);\n  line-height: 1.6;\n  color: #333;\n}\n\n/* Stats */\n.mm-modal-stats {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(5rem, 1fr));\n  gap: clamp(0.5rem, 1vw, 1rem);\n  padding: clamp(0.75rem, 1.5vw, 1rem);\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: clamp(0.5rem, 1vw, 0.75rem);\n  display: \"flex\";\n  flex-direction: row;\n}\n\n.mm-modal-stats-left {\n  width: \"80%\";\n  height: \"100%\";\n  display: \"flex\";\n  flex-direction: \"row\";\n  justify-items: flex-start;\n  background: \"red\";\n}\n\n.mm-modal-stats-right {\n  width: \"20%\";\n  height: \"100%\";\n  display: \"flex\";\n  flex-direction: \"row\";\n  justify-items: flex-end;\n  margin-right: 20px;\n}\n\n.mm-modal-stat-item {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.mm-modal-stat-icon {\n  font-size: clamp(1.25rem, 2vw, 1.5rem);\n  color: \"white\";\n  font-size: 15px;\n  font-weight: bold;\n}\n\n.mm-modal-stat-value {\n  font-size: clamp(0.875rem, 1.3vw, 1rem);\n  font-weight: bold;\n  color: white;\n  font-size: 15px;\n  font-weight: bold;\n}\n\n/* Comments Section */\n.mm-modal-comments-section {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.75rem, 1.5vw, 1rem);\n}\n\n.mm-modal-comments-title {\n  margin: 0;\n  font-size: clamp(1rem, 1.5vw, 1.125rem);\n  font-weight: bold;\n  color: white;\n}\n\n.mm-modal-comments-list {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.5rem, 1vw, 0.75rem);\n  max-height: 15rem;\n  overflow-y: auto;\n  padding: clamp(0.5rem, 1vw, 0.75rem);\n  background: rgba(0, 0, 0, 0.02);\n  border-radius: clamp(0.5rem, 1vw, 0.75rem);\n  height: 140px;\n}\n\n.mm-modal-comment {\n  display: flex;\n  flex-direction: column;\n  gap: 0.25rem;\n  padding-bottom: clamp(0.5rem, 1vw, 0.75rem);\n  border-bottom: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.mm-modal-comment:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.mm-modal-comment-user {\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  font-weight: bold;\n  color: #1a1a1a;\n}\n\n.mm-modal-comment-text {\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  color: #333;\n  line-height: 1.5;\n}\n\n.mm-modal-comment-time {\n  font-size: clamp(0.625rem, 1vw, 0.75rem);\n  color: #999;\n}\n\n.mm-modal-no-comments {\n  text-align: center;\n  color: #999;\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  padding: clamp(1rem, 2vw, 1.5rem);\n}\n\n/* Add Comment */\n.mm-modal-add-comment {\n  display: flex;\n  gap: clamp(0.5rem, 1vw, 0.75rem);\n}\n\n.mm-modal-comment-input {\n  flex: 1;\n  padding: clamp(0.5rem, 1vw, 0.75rem);\n  border: 1px solid rgba(0, 0, 0, 0.2);\n  border-radius: clamp(0.5rem, 1vw, 0.75rem);\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  outline: none;\n  transition: border-color 0.3s ease;\n  background: rgba(36,36,45,0.2);\n  color: white;\n}\n\n.mm-modal-comment-input:focus {\n  border-color: #007bff;\n}\n\n.mm-modal-comment-button {\n  padding: clamp(0.5rem, 1vw, 0.75rem) clamp(1rem, 2vw, 1.5rem);\n  background: #007bff;\n  color: white;\n  border: none;\n  border-radius: clamp(0.5rem, 1vw, 0.75rem);\n  font-size: clamp(0.75rem, 1.2vw, 0.875rem);\n  font-weight: bold;\n  cursor: pointer;\n  transition: background 0.3s ease, transform 0.2s ease;\n}\n\n.mm-modal-comment-button:hover {\n  background: #0056b3;\n  transform: translateY(-0.125rem);\n}\n\n/* Audio Container */\n.mm-audio-container {\n  display: flex;\n  flex-direction: column;\n  gap: clamp(0.5rem, 1vw, 0.75rem);\n  padding: clamp(0.75rem, 1.5vw, 1rem);\n  background: rgba(0, 0, 0, 0.05);\n  border-radius: clamp(0.5rem, 1vw, 0.75rem);\n}\n\n.mm-audio-container audio {\n  width: 100%;\n}\n\n/* ==================== RESPONSIVE BREAKPOINTS ==================== */\n\n/* Tablet and larger */\n@media (min-width: 48rem) {\n  .mm-modal-content {\n    grid-template-columns: 1.5fr 1fr;\n  }\n\n  .mm-modal-media-section {\n    max-height: 80vh;\n  }\n\n  .mm-modal-media {\n    max-height: 80vh;\n  }\n\n  .mm-modal-details-section {\n    max-height: 80vh;\n  }\n}\n\n/* Mobile optimization */\n@media (max-width: 47.9375rem) {\n  .mm-grid-container {\n    grid-template-columns: repeat(2, 1fr) !important;\n  }\n\n  .mm-modal-overlay {\n    padding: 0;\n  }\n\n  .mm-modal-container {\n    border-radius: 0;\n    height: 100%;\n  }\n\n  .mm-modal-content {\n    height: 100%;\n  }\n\n  .mm-modal-details-section {\n    max-height: none;\n  }\n}\n\n\n/* ============================================ */\n/*  LOGO + QUALITY STARS ROW                    */\n/* ============================================ */\n.mm-logo-quality-row {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  padding: 10px 0;\n  margin-bottom: 8px;\n}\n\n.mm-logo-wrap {\n  flex-shrink: 0;\n}\n\n.mm-modal-logo {\n  height: 40px;\n  width: 40px;\n  object-fit: contain;\n  border-radius: 8px;\n}\n\n.mm-quality-stars {\n  display: flex;\n  align-items: center;\n  gap: 2px;\n}\n\n.mm-quality-label {\n  margin-left: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #FFD700;\n  letter-spacing: 0.04em;\n}\n\n/* ============================================ */\n/*  ABOUT SECTION                               */\n/* ============================================ */\n.mm-about-section {\n  width: 100%;\n  padding: 12px 14px;\n  border-radius: 10px;\n  margin-bottom: 12px;\n  margin-top: -20px;\n}\n\n.mm-about-row {\n  display: flex;\n  gap: 8px;\n  padding: 4px 0;\n  font-size: 13px;\n}\n\n.mm-about-label {\n  color: rgba(255, 255, 255, 0.5);\n  flex-shrink: 0;\n  min-width: 90px;\n}\n\n.mm-about-value {\n  color: rgba(255, 255, 255, 0.9);\n}\n\n/* ============================================ */\n/*  METADATA INPUTS (highlighted)               */\n/* ============================================ */\n.mm-metadata-row {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 8px 0;\n  margin-top: 6px;\n}\n\n.mm-metadata-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.6);\n  flex-shrink: 0;\n  min-width: 110px;\n}\n\n.mm-metadata-select {\n  flex: 1;\n  height: 32px;\n  padding: 0 10px;\n  border-radius: 6px;\n  border: 1px solid rgba(168, 139, 250, 0.2);\n  background: rgba(36, 36, 45, 0.5);\n  color: white;\n  font-size: 12px;\n  cursor: pointer;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n}\n\n/* Highlighted state — draws the eye to these two fields */\n.mm-metadata-select--highlight {\n  border-color: rgba(255, 193, 7, 0.4);\n  background: rgba(255, 193, 7, 0.08);\n  color: #ffc107;\n  font-weight: 600;\n}\n\n.mm-metadata-select--highlight:hover,\n.mm-metadata-select--highlight:focus {\n  border-color: rgba(255, 193, 7, 0.7);\n  box-shadow: 0 0 0 2px rgba(255, 193, 7, 0.15);\n  outline: none;\n}\n\n.mm-metadata-select--highlight option {\n  background: #1a1a22;\n  color: white;\n  font-weight: 400;\n}\n\n/* ============================================ */\n/*  DOUBLE-CLICK LIKE HINT                      */\n/* ============================================ */\n.mm-double-click-hint {\n  font-size: 11px;\n  color: rgba(255, 255, 255, 0.4);\n  text-align: center;\n  margin-top: 8px;\n  letter-spacing: 0.03em;\n}\n\n/* ============================================ */\n/*  ACTION BUTTONS (Share / Suggest)            */\n/* ============================================ */\n.mm-action-btn-wrapper {\n  position: relative;\n}\n\n.mm-action-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 4px 10px;\n  border-radius: 8px;\n  border: 1px solid gray;\n  background: rgba(36,36,45,0.2);\n  color: white;\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.18s ease, border-color 0.18s ease;\n}\n\n/* ============================================ */\n/*  SHARE DROPDOWN                              */\n/* ============================================ */\n.mm-share-dropdown {\n  position: absolute;\n  bottom: 100%;\n  left: 0;\n  margin-bottom: 8px;\n  background: rgba(20, 20, 28, 0.98);\n  border: 1px solid rgba(168, 139, 250, 0.25);\n  border-radius: 12px;\n  padding: 6px;\n  min-width: 180px;\n  z-index: 100;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n}\n\n.mm-share-option {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  padding: 10px 14px;\n  border: none;\n  background: transparent;\n  color: white;\n  cursor: pointer;\n  border-radius: 8px;\n  font-size: 13px;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.mm-share-option:hover {\n  background: rgba(168, 139, 250, 0.15);\n}\n\n.mm-share-icon {\n  width: 24px;\n  height: 24px;\n  border-radius: 6px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.mm-share-icon--facebook { background: #1877F2; color: white; }\n.mm-share-icon--instagram { background: #E1306C; }\n.mm-share-icon--snapchat { background: #FFFC00; }\n.mm-share-icon--tiktok { background: #000; color: white; border: 1px solid #25F4EE; }\n\n/* ============================================ */\n/*  SUGGEST MODAL                               */\n/* ============================================ */\n.mm-suggest-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.7);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 200;\n}\n\n.mm-suggest-modal {\n  background: rgba(20, 20, 28, 0.98);\n  border: 1px solid darkslategray;\n  border-radius: 16px;\n  padding: 28px 32px;\n  width: 90%;\n  max-width: 420px;\n  position: relative;\n}\n\n.mm-suggest-close {\n  position: absolute;\n  top: 12px;\n  right: 16px;\n  background: transparent;\n  border: none;\n  color: rgba(255, 255, 255, 0.6);\n  font-size: 18px;\n  cursor: pointer;\n}\n\n.mm-suggest-close:hover { color: white; }\n\n.mm-suggest-title {\n  font-size: 18px;\n  font-weight: 700;\n  color: white;\n  margin: 0 0 8px 0;\n}\n\n.mm-suggest-help {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.5);\n  line-height: 1.5;\n  margin: 0 0 20px 0;\n}\n\n.mm-suggest-input-row {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-bottom: 24px;\n}\n\n.mm-suggest-label {\n  font-size: 12px;\n  font-weight: 600;\n  color: rgba(255, 255, 255, 0.7);\n  letter-spacing: 0.04em;\n}\n\n.mm-suggest-input {\n  height: 42px;\n  padding: 0 14px;\n  border-radius: 10px;\n  border: 1px solid rgba(168, 139, 250, 0.25);\n  background: rgba(36, 36, 45, 0.6);\n  color: white;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease;\n}\n\n.mm-suggest-input:focus {\n  border-color: rgba(168, 139, 250, 0.6);\n  box-shadow: 0 0 0 3px rgba(168, 139, 250, 0.12);\n}\n\n.mm-suggest-input::placeholder {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mm-suggest-actions {\n  display: flex;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.mm-suggest-cancel {\n  padding: 10px 18px;\n  border-radius: 10px;\n  border: 1px solid rgba(255, 255, 255, 0.15);\n  background: transparent;\n  color: rgba(255, 255, 255, 0.7);\n  cursor: pointer;\n  font-size: 13px;\n  transition: background 0.15s ease;\n}\n\n.mm-suggest-cancel:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\n.mm-suggest-submit {\n  padding: 10px 22px;\n  border-radius: 10px;\n  border: none;\n  background: linear-gradient(135deg, #7c3aed, #4c1d95);\n  color: white;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n}\n\n.mm-suggest-submit:hover { transform: translateY(-1px); }\n.mm-suggest-submit:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ============================================ */\n/*  TOAST NOTIFICATION                          */\n/* ============================================ */\n.mm-toast {\n  position: fixed;\n  bottom: 24px;\n  left: 50%;\n  transform: translateX(-50%);\n  background: rgba(20, 20, 28, 0.98);\n  border: 1px solid rgba(168, 139, 250, 0.3);\n  border-radius: 12px;\n  padding: 14px 24px;\n  color: white;\n  font-size: 13px;\n  z-index: 300;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.5);\n  animation: mmToastIn 0.3s ease;\n}\n\n@keyframes mmToastIn {\n  from { opacity: 0; transform: translate(-50%, 20px); }\n  to   { opacity: 1; transform: translate(-50%, 0); }\n}\n\n/* ============================================ */\n/*  METADATA HIGHLIGHT (from previous update)   */\n/* ============================================ */\n.mm-metadata-highlight {\n  background: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n  font-weight: 600;\n  padding: 4px 10px;\n  border-radius: 6px;\n  border: 1px solid rgba(255, 193, 7, 0.25);\n}\n\n.mm-metadata-value {\n  font-size: 13px;\n  margin: 0;\n}\n\n/* ============================================ */\n/*  COMMENT THREAD + REPLY BUTTON               */\n/* ============================================ */\n.mm-comment-thread {\n  margin-bottom: 12px;\n}\n\n.mm-modal-comment {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 8px 12px;\n  border-radius: 10px;\n  background: rgba(36, 36, 45, 0.3);\n  border: 1px solid rgba(168, 139, 250, 0.1);\n}\n\n.mm-comment-body {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  line-height: 1.5;\n}\n\n/* Reply button */\n.mm-reply-btn {\n  flex-shrink: 0;\n  padding: 4px 12px;\n  border-radius: 6px;\n  border: 1px solid darkslategray;\n  background: transparent;\n  color: gray;\n  font-size: 11px;\n  font-weight: 600;\n  cursor: pointer;\n  letter-spacing: 0.03em;\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n/* .mm-reply-btn:hover {\n  background: rgba(168, 139, 250, 0.12);\n  border-color: rgba(168, 139, 250, 0.5);\n  color: #a78bfa;\n}\n\n.mm-reply-btn--active {\n  background: rgba(255, 99, 99, 0.12);\n  border-color: rgba(255, 99, 99, 0.4);\n  color: #ff6363;\n} */\n\n/* ============================================ */\n/*  INLINE REPLY INPUT                          */\n/* ============================================ */\n.mm-reply-input-row {\n  margin-top: 8px;\n  margin-left: 24px;\n  padding: 10px 14px;\n  border-radius: 10px;\n  background: rgba(36,36,45,0.2);\n  border: 1px solid darkslategray;\n}\n\n.mm-reply-mention {\n  display: block;\n  font-size: 11px;\n  color: rgba(168, 139, 250, 0.7);\n  margin-bottom: 6px;\n  font-style: italic;\n}\n\n.mm-reply-input-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.mm-reply-input {\n  flex: 1;\n  height: 34px;\n  padding: 0 12px;\n  border-radius: 8px;\n  border: 1px solid rgba(168, 139, 250, 0.2);\n  background: rgba(36, 36, 45, 0.6);\n  color: white;\n  font-size: 12px;\n  outline: none;\n  transition: border-color 0.18s ease;\n}\n\n.mm-reply-input:focus {\n  border-color: rgba(168, 139, 250, 0.5);\n}\n\n.mm-reply-input::placeholder {\n  color: rgba(255, 255, 255, 0.3);\n}\n\n.mm-reply-submit-btn {\n  flex-shrink: 0;\n  padding: 0 16px;\n  height: 34px;\n  border-radius: 8px;\n  border: none;\n  background: rgba(36,36,45,0.2);\n  color: white;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: opacity 0.15s ease, transform 0.15s ease;\n  border: \"1px solid darkslategray\";\n}\n\n.mm-reply-submit-btn:hover { transform: translateY(-1px); }\n.mm-reply-submit-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n  transform: none;\n}\n\n/* ============================================ */\n/*  NESTED REPLIES                              */\n/* ============================================ */\n.mm-replies-container {\n  margin-top: 8px;\n  margin-left: 24px;\n  padding-left: 14px;\n  border-left: 2px solid rgba(168, 139, 250, 0.2);\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.mm-reply-item {\n  display: flex;\n  gap: 10px;\n  padding: 8px 12px;\n  border-radius: 8px;\n  background: rgba(36, 36, 45, 0.2);\n}\n\n/* Small avatar with first letter of the replier's userId */\n.mm-reply-avatar {\n  flex-shrink: 0;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: linear-gradient(135deg, #7c3aed, #4c1d95);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.mm-reply-avatar-text {\n  font-size: 12px;\n  font-weight: 700;\n  color: white;\n  text-transform: uppercase;\n}\n\n.mm-reply-content {\n  flex: 1;\n  min-width: 0;\n}\n\n.mm-reply-header {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  flex-wrap: wrap;\n  margin-bottom: 2px;\n}\n\n.mm-reply-user {\n  font-size: 12px;\n  color: #a78bfa;\n}\n\n/* \"→ @username\" shown when the reply is addressed to someone\n   other than the parent comment's author */\n.mm-reply-mention-inline {\n  font-size: 11px;\n  color: rgba(168, 139, 250, 0.6);\n  font-style: italic;\n}\n\n.mm-reply-time {\n  font-size: 10px;\n  color: rgba(255, 255, 255, 0.3);\n  margin-left: auto;\n}\n\n.mm-reply-text {\n  font-size: 12px;\n  color: rgba(255, 255, 255, 0.85);\n  line-height: 1.4;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
